/* Protocolo de verificación en la PDP — port del MVP final (FINAL-BRIEF F1, de
   m02-verificador). Desde el cambio Kike 12/07 es un ACORDEÓN MÁS de
   .pdp-acordeones (segundo, tras FICHA TÉCNICA): cerrado se ve idéntico a los
   demás; abierto conserva la secuencia de checks (ritmo Kike 11/07: cada check
   "escanea" ~0.5s y luego marca OK), re-disparada en cada apertura; con
   prefers-reduced-motion abre con todo ya en ✓. El CSS define el estado final
   (patrón .from): sin JS la página queda completa y sin protocolo (aditivo).
   Se carga DESPUÉS de pdp.js (ambos defer); usa window.PDP_PRODUCT (server-side). */
(function () {
  "use strict";
  var RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Checklist por producto (regla de datos del FINAL-BRIEF, sobre category/type/brand;
     en el theme brand = vendor de Shopify). Expuesta en parse-time como
     window.VF.checklist: pdp.js la usa para la fila VERIFICACIÓN de la ficha técnica. */
  function checklist(p) {
    if (p.category === "tenis")
      return ["Costuras", "Materiales", "Caja y etiquetas", "Detalles internos", "Procedencia"];
    if (p.category === "ropa")
      return ["Etiquetas", "Bolsa", "Sin defectos", "Importada directamente"];
    if ((p.type === "Lentes" && p.brand === "FREDDI") ||
        (p.type === "Gorra" && p.brand === "KIBLO CAPS"))
      return ["Nuevo", "Sin defectos", "Distribuidores autorizados"];
    return ["Nuevos", "Sin defectos"]; /* accesorios restantes, relojes, bolsas, coleccionables… */
  }
  window.VF = { checklist: checklist };

  function initPdp() {
    var gal = document.getElementById("galeria");
    var p = window.PDP_PRODUCT;
    if (!gal || !p || document.querySelector(".vf-proto")) return;
    var PUNTOS = checklist(p);
    var n = PUNTOS.length;

    var d = document.createElement("details");
    d.className = "vf-proto";
    /* estado final en el markup: todos los checks ✓ y "Pieza auténtica ✓" —
       la secuencia solo QUITA ese estado al abrir (cuando está garantizada).
       El summary es un acordeón MÁS: cerrado se ve idéntico a FICHA TÉCNICA /
       GARANTÍA / ENVÍOS; el estado azul solo aparece abierto (CSS). */
    d.innerHTML =
      '<summary><span class="vf-proto-t">Protocolo de verificación — ' + n + ' puntos</span>' +
        '<span class="vf-proto-estado">Pieza auténtica ✓</span></summary>' +
      '<ul class="vf-checks">' + PUNTOS.map(function (c) {
        return '<li class="vf-check ok"><button type="button" aria-label="' + c +
          ' — ver garantía de autenticidad"><span>' + c + '</span></button></li>';
      }).join("") + '</ul>' +
      '<p class="vf-proto-nota">El mismo protocolo que corremos en tienda, pieza por pieza. ' +
        '<a href="/pages/garantia">Garantía de autenticidad</a>.</p>';

    /* colocación (cambio Kike 12/07): el protocolo es el SEGUNDO acordeón de la
       PDP (tras FICHA TÉCNICA), en móvil y desktop por igual. Idempotente. */
    var placeProto = function () {
      var ac = document.querySelector("#pdpCol .pdp-acordeones");
      if (!ac) return;
      var first = ac.querySelector("details");
      if (first && first !== d && first.nextElementSibling !== d) first.after(d);
    };
    placeProto();
    /* elegir talla re-renderiza la columna y col() snapshotea los <details> por
       índice: el panel se desmonta ANTES del re-render y se re-coloca después —
       mismo nodo, estado y listeners intactos (lección de m02). */
    if (window.PDP && PDP.talla) {
      var _talla = PDP.talla;
      PDP.talla = function (i) { d.remove(); _talla.call(PDP, i); placeProto(); };
    }

    /* tocar un check abre el acordeón de GARANTÍA existente */
    d.querySelectorAll(".vf-check button").forEach(function (b) {
      b.addEventListener("click", function () {
        var target = null;
        document.querySelectorAll("#pdpCol .pdp-acordeones details").forEach(function (x) {
          var s = x.querySelector("summary");
          if (s && /garant/i.test(s.textContent)) target = x;
        });
        if (target) {
          target.open = true;
          target.scrollIntoView({ block: "center", behavior: RM ? "auto" : "smooth" });
        }
      });
    });

    /* la secuencia corre AL ABRIR; al cerrar se cancelan los timers y se restaura
       el estado final. Con RM no hay secuencia (abre con todo en ✓). */
    if (RM) return;
    var estado = d.querySelector(".vf-proto-estado");
    var checks = d.querySelectorAll(".vf-check");
    var timers = [];
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    function finalState() {
      checks.forEach(function (c) { c.classList.remove("scan"); c.classList.add("ok"); });
      estado.textContent = "Pieza auténtica ✓";
      estado.classList.remove("vf-run");
    }
    /* ritmo lento (Kike 11/07): los checks van UNO POR UNO — cada uno "escanea"
       ~0.5s (○ azul pulsando + ESCANEANDO) y recién entonces marca OK */
    var SCAN = 500, GAP = 150, ARRANQUE = 200;
    d.addEventListener("toggle", function () {
      clearTimers();
      if (!d.open) { finalState(); return; }
      checks.forEach(function (c) { c.classList.remove("ok", "scan"); });
      estado.textContent = "Verificando…";
      estado.classList.add("vf-run");
      checks.forEach(function (c, i) {
        var t0 = ARRANQUE + i * (SCAN + GAP);
        timers.push(setTimeout(function () { c.classList.add("scan"); }, t0));
        timers.push(setTimeout(function () { c.classList.remove("scan"); c.classList.add("ok"); }, t0 + SCAN));
      });
      timers.push(setTimeout(finalState, ARRANQUE + checks.length * (SCAN + GAP) + 150));
    });
  }

  document.addEventListener("DOMContentLoaded", initPdp);
})();
